import { Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';

export function parseLearningFormats(field: Field | Item | Item[] | undefined): string[] | null {
	let learningFormats: string[] | null = [];
	try {
		(field as Item[])?.map((learningFormat) => learningFormats?.push((learningFormat?.fields?.Title as Field<string>).value));
	} catch (error) {
		console.error(error);
		learningFormats = null;
	}

	return learningFormats;
}
